import { Component, OnInit } from '@angular/core';
import { ProductService } from 'src/app/services/api/product.service';
import { LangService } from 'src/app/services/lang/lang.service';

@Component({
  selector: 'app-cancelartwork',
  templateUrl: './cancelartwork.component.html',
  styleUrls: ['./cancelartwork.component.scss']
})
export class CancelartworkComponent implements OnInit {
  onClose: any;
  onCancel: any;

  item: any = null;
  order: any = null;
  product: any = null;
  cancelMsg: any = '';

  constructor(
    public lang : LangService,
    public productService: ProductService
  ) { }

  ngOnInit() {
  }

  closeModal(){
    this.onClose();
  }

  cancelArtwork(){
    if(this.cancelMsg.length > 0){
      this.onCancel(this.cancelMsg);
    } else {
      this.productService.toastService.add(this.lang.getLang('l93a'), 'danger');
    }
  }

}
